import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { brandAssets } from '../utils/mockData';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img src={brandAssets.logo.circular} alt="Balanced Bites Cafe" className="h-16 w-16" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('menu')}
              className="text-[#59642C] hover:text-[#FE9E1C] transition-colors duration-200 font-medium"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('chef')}
              className="text-[#59642C] hover:text-[#FE9E1C] transition-colors duration-200 font-medium"
            >
              Our Chef
            </button>
            <button
              onClick={() => scrollToSection('approach')}
              className="text-[#59642C] hover:text-[#FE9E1C] transition-colors duration-200 font-medium"
            >
              Our Approach
            </button>
            <button
              onClick={() => scrollToSection('locations')}
              className="text-[#59642C] hover:text-[#FE9E1C] transition-colors duration-200 font-medium"
            >
              Locations
            </button>
            <button
              onClick={() => scrollToSection('partner')}
              className="text-[#59642C] hover:text-[#FE9E1C] transition-colors duration-200 font-medium"
            >
              Partner With Us
            </button>
            <Button
              onClick={() => scrollToSection('partner')}
              className="bg-[#FE9E1C] hover:bg-[#e68a0f] text-white px-6 py-2 transition-all duration-200"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#59642C] p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#EBEBD3] py-4 space-y-3">
            <button
              onClick={() => scrollToSection('menu')}
              className="block w-full text-left px-4 py-2 text-[#59642C] hover:bg-[#EBEBD3]/30 transition-colors"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('chef')}
              className="block w-full text-left px-4 py-2 text-[#59642C] hover:bg-[#EBEBD3]/30 transition-colors"
            >
              Our Chef
            </button>
            <button
              onClick={() => scrollToSection('approach')}
              className="block w-full text-left px-4 py-2 text-[#59642C] hover:bg-[#EBEBD3]/30 transition-colors"
            >
              Our Approach
            </button>
            <button
              onClick={() => scrollToSection('locations')}
              className="block w-full text-left px-4 py-2 text-[#59642C] hover:bg-[#EBEBD3]/30 transition-colors"
            >
              Locations
            </button>
            <button
              onClick={() => scrollToSection('partner')}
              className="block w-full text-left px-4 py-2 text-[#59642C] hover:bg-[#EBEBD3]/30 transition-colors"
            >
              Partner With Us
            </button>
            <div className="px-4 pt-2">
              <Button
                onClick={() => scrollToSection('partner')}
                className="w-full bg-[#FE9E1C] hover:bg-[#e68a0f] text-white"
              >
                Get Started
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
